export const SIDEBAR_COLLAPSED_STORAGE_KEY = "faro-sidebar-collapsed";

type ReadableStorage = Pick<Storage, "getItem">;
type WritableStorage = Pick<Storage, "setItem">;

export function readStoredSidebarCollapsed(storage: ReadableStorage): boolean {
  try {
    return storage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function storeSidebarCollapsed(storage: WritableStorage, collapsed: boolean): void {
  try {
    storage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(collapsed));
  } catch {
    // Browser policy can disable storage; the sidebar still works for this session.
  }
}
